import React, { Component } from "react";
import { connect } from "react-redux";
import { map } from "lodash";
import UserWidget from "../../../UI/UserWidget";

class Results extends Component {
  render() {
    const { results } = this.props;
    return (
      <div className="row">
        {map(results, result => (
          <div key={result.id} className="col-md-4">
            <UserWidget user={result} />
          </div>
        ))}
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  results: state.search.results
});

export default connect(mapStateToProps)(Results);



// WEBPACK FOOTER //
// ./src/_components/Search/Name/Results/index.js